import { Link } from "react-router-dom";
import { hotSearches, articles } from "@/mocks/articles";

function formatHeat(heat: number): string {
  if (heat >= 1000000) return `${(heat / 1000000).toFixed(1)}M`;
  if (heat >= 1000) return `${(heat / 1000).toFixed(0)}K`;
  return `${heat}`;
}

export default function HotTopicsTicker() {
  return (
    <section className="py-8 md:py-10 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-2.5">
            <h2 className="text-lg md:text-xl font-extrabold text-foreground-950">
              热搜<span className="text-red-500">爆料</span>
            </h2>
            <span className="text-sm text-foreground-500">吃瓜风向标</span>
          </div>
          <span className="px-3 py-1 text-[11px] font-semibold bg-red-50 text-red-600 rounded-full flex items-center gap-1">
            <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse"></span>
            实时
          </span>
        </div>

        <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
          {hotSearches.map((item) => {
            const article = articles.find((a) => a.id === item.articleId);
            return (
              <Link
                key={item.rank}
                to={`/article/${article?.slug || "top-wanghong-zhang-san-collapse"}`}
                className="flex items-center gap-3 shrink-0 bg-background-100 hover:bg-background-200/70 rounded-lg px-4 py-3 transition-colors min-w-[280px] md:min-w-[320px] group"
              >
                <span
                  className={`text-lg font-black w-7 h-7 flex items-center justify-center rounded ${
                    item.rank === 1
                      ? "text-white bg-red-500"
                      : item.rank === 2
                        ? "text-white bg-accent-500"
                        : item.rank === 3
                          ? "text-white bg-secondary-500"
                          : "text-foreground-400 bg-background-200"
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                    {item.keyword}
                  </p>
                  <p className="text-[11px] text-foreground-500 mt-0.5">
                    热度 {formatHeat(item.heat)}
                  </p>
                </div>
                <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}